import './Navbar.css'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Logo from './Logo'
import { CartIcon, HeartIcon } from './Icons'
import Usermenu from './UserMenu';
import WishlistDrawer from './Wishlistdrawer'
import { useCart } from '../context/CartContext'
import { byOrder, useCategories, useCategoryBrands, useDevices } from '../hooks/useSiteData'

export default function Navbar() {
  const { count, wish, setOpen, setWishOpen } = useCart()
  const [menu, setMenu] = useState(null)      // 'device' | 'acc' | null
  const [mobile, setMobile] = useState(false)
  const [q, setQ] = useState('')
  const go = useNavigate()
  const DEVICES = useDevices() // only brands and models that have products
  const catBrands = useCategoryBrands() // brands that have products, per category
  const CATEGORIES = [...useCategories()].sort(byOrder).map(c => c.name)
  const close = () => { setMenu(null); setMobile(false) }
  const search = e => { e.preventDefault(); go(`/shop?q=${encodeURIComponent(q)}`); close() }
  const item = (key, label) => (
    <div className="nav__item" onMouseEnter={() => setMenu(key)}>
      <button className="nav__link" aria-expanded={menu === key} onClick={() => setMenu(menu === key ? null : key)}>{label} ▾</button>
    </div>
  )

  return (
    <header className="nav" onMouseLeave={() => setMenu(null)}>
      <div className="nav__bar">
        <button className="nav__burger" onClick={() => setMobile(!mobile)} aria-label="Menu" aria-expanded={mobile}>
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
            {mobile ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
          </svg>
        </button>
        <Link className="nav__logo" to="/" aria-label="iPOINT home" onClick={close}><Logo /></Link>
        <nav className="nav__links" aria-label="Main">
          {Object.keys(DEVICES).length > 0 && item('device', 'Shop by device')}
          {CATEGORIES.length > 0 && item('acc', 'Accessories')}
          <Link className="nav__link" to="/#repair" onMouseEnter={() => setMenu(null)}>Repair</Link>
          <Link className="nav__link" to="/shop" onMouseEnter={() => setMenu(null)}>Shop all</Link>
        </nav>
        <form className="nav__search" onSubmit={search} role="search">
          <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search products" aria-label="Search products" />
        </form>
        <div className="nav__user"><Usermenu /></div>
        <button className="nav__icon" onClick={() => setWishOpen(true)} aria-haspopup="dialog" aria-label={`Open wishlist, ${wish.length} items`}>
          <HeartIcon />
          {wish.length > 0 && <span className="nav__count nav__count--wish" aria-hidden="true">{wish.length}</span>}
        </button>
        <button className="nav__cart" onClick={() => setOpen(true)} aria-label={`Open cart, ${count} items`}>
          <CartIcon />
          {count > 0 && <span className="nav__count" aria-hidden="true">{count}</span>}
        </button>
      </div>

      {menu === 'device' && (
        <div className="mega" onMouseEnter={() => setMenu('device')}>
          {Object.entries(DEVICES).map(([brand, models]) => (
            <div key={brand}>
              <h4><Link to={`/shop?brand=${brand}`} onClick={close}>{brand}</Link></h4>
              <ul>{models.map(m => <li key={m}><Link to={`/shop?model=${encodeURIComponent(m)}`} onClick={close}>{m}</Link></li>)}</ul>
            </div>
          ))}
        </div>
      )}
      {menu === 'acc' && (
        <div className="mega mega--acc" onMouseEnter={() => setMenu('acc')}>
          {CATEGORIES.map(c => (
            <div key={c}>
              <h4><Link to={`/shop?category=${encodeURIComponent(c)}`} onClick={close}>{c}</Link></h4>
              {(catBrands[c] || []).length > 0 && (
                <ul>
                  {catBrands[c].map(b => (
                    <li key={b}><Link to={`/shop?category=${encodeURIComponent(c)}&brand=${encodeURIComponent(b)}`} onClick={close}>{b}</Link></li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      )}
      {mobile && (
        <div className="mobile">
          <Link to="/shop" onClick={close}>Shop all</Link>
          <Link to="/#repair" onClick={close}>Repair</Link>
          {Object.keys(DEVICES).map(b => <Link key={b} to={`/shop?brand=${b}`} onClick={close}>{b}</Link>)}
          {CATEGORIES.map(c => <Link key={c} to={`/shop?category=${encodeURIComponent(c)}`} onClick={close}>{c}</Link>)}
        </div>
      )}
      <WishlistDrawer />
    </header>
  )
}